import essApi from "../axios/essApi";

class MyProjectService {

    async getProjectsByUser() {
        return Promise.resolve(essApi.get(`projects-by-user?myProject=true`));
    }
}

export default MyProjectService;